import { render, staticRenderFns } from "./Eugenio.vue?vue&type=template&id=47eeb2e3&"
import script from "./Eugenio.vue?vue&type=script&lang=js&"
export * from "./Eugenio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports